const desktopNavigationMedia = window.matchMedia('(min-width: 990px)');
let mobileMenuWasOpen = false;
let mobileSubmenuObserver;

function syncMobileSubmenuExpandedState() {
  document.querySelectorAll('#NavDrawer [data-cs-submenu-toggle]').forEach(button => {
    const row = button.closest('.mobile-nav__has-sublist');
    button.setAttribute('aria-expanded', String(row?.classList.contains('mobile-nav--expanded') || false));
  });
}

function initializeMobileSubmenuState() {
  mobileSubmenuObserver?.disconnect();
  const drawer = document.getElementById('NavDrawer');
  if (!drawer) return;

  // The vendor still controls disclosure visibility. Keep one persistent button
  // focused while only its decorative chevrons change, and mirror actual state.
  mobileSubmenuObserver = new MutationObserver(syncMobileSubmenuExpandedState);
  mobileSubmenuObserver.observe(drawer, { subtree: true, attributes: true, attributeFilter: ['class'] });
  syncMobileSubmenuExpandedState();
}

function getMobileMenuTrigger() {
  return document.querySelector('.js-drawer-open-left-link');
}

function getDesktopNavigationTarget() {
  return (
    document.querySelector('.site-header nav[aria-label="Primary"] a') ||
    document.querySelector('.site-header a[href="/"]') ||
    document.querySelector('.site-header a, .site-header button')
  );
}

function restoreFocusAfterMobileMenuClose() {
  const target = desktopNavigationMedia.matches ? getDesktopNavigationTarget() : getMobileMenuTrigger();
  if (!target?.isConnected) return;

  requestAnimationFrame(() => {
    if (target.isConnected) target.focus();
  });
}

function syncMobileMenuExpandedState() {
  const trigger = getMobileMenuTrigger();
  if (!trigger) return;

  const isOpen = !desktopNavigationMedia.matches && document.body.classList.contains('js-drawer-open-left');
  trigger.setAttribute('aria-expanded', String(isOpen));

  if (mobileMenuWasOpen && !isOpen) {
    restoreFocusAfterMobileMenuClose();
  }

  mobileMenuWasOpen = isOpen;
}

function closeMobileMenuAtDesktopBreakpoint(event) {
  if (!event.matches || !document.body.classList.contains('js-drawer-open-left')) return;

  window.wetheme?.toggleLeftDrawer?.(false);
  syncMobileMenuExpandedState();
}

function initializeMobileMenuBreakpoint() {
  initializeMobileSubmenuState();
  const drawerStateObserver = new MutationObserver(syncMobileMenuExpandedState);
  drawerStateObserver.observe(document.body, { attributes: true, attributeFilter: ['class'] });

  if (desktopNavigationMedia.addEventListener) {
    desktopNavigationMedia.addEventListener('change', closeMobileMenuAtDesktopBreakpoint);
    desktopNavigationMedia.addEventListener('change', resetDesktopDropdowns);
  } else {
    desktopNavigationMedia.addListener(closeMobileMenuAtDesktopBreakpoint);
    desktopNavigationMedia.addListener(resetDesktopDropdowns);
  }

  closeMobileMenuAtDesktopBreakpoint(desktopNavigationMedia);
  syncMobileMenuExpandedState();
}

// Desktop complements the mobile drawer: Escape dismisses focus/hover content
// without the vendor's focusin handler immediately opening it again.
const dismissedDesktopMenuClass = 'cs-nav-dismissed';

function clearDesktopMenuDismissal(parent) {
  parent.classList.remove(dismissedDesktopMenuClass);
}

function handleDesktopMenuKeyDown(event) {
  if (!desktopNavigationMedia.matches) return;
  const nav = event.target.closest?.('#AccessibleNav');
  if (!nav) return;
  const parent = event.target.closest('.site-nav--has-dropdown');
  if (!parent || !nav.contains(parent)) return;
  const trigger = parent.querySelector(':scope > a');
  const submenu = parent.querySelector(':scope > .site-nav__dropdown, :scope > .site-nav__subdropdown');
  if (!trigger || !submenu) return;

  if (event.key === 'ArrowDown' && event.target === trigger && parent.classList.contains(dismissedDesktopMenuClass)) {
    event.preventDefault();
    clearDesktopMenuDismissal(parent);
    parent.classList.add('nav-hover');
    submenu.querySelector('a[href]')?.focus();
    return;
  }

  if (event.key !== 'Escape' && event.keyCode !== 27) return;
  if (getComputedStyle(submenu).visibility === 'hidden' || getComputedStyle(submenu).display === 'none') return;
  event.preventDefault();
  event.stopPropagation();
  parent.classList.add(dismissedDesktopMenuClass);
  trigger.focus();
  // Focus restoration runs the vendor's synchronous open handler first.
  parent.classList.remove('nav-hover');
  parent.querySelectorAll('.nav-hover').forEach(child => child.classList.remove('nav-hover'));
  if (!nav.querySelector('.nav-hover')) {
    nav.closest('.site-header')?.classList.remove('force-hover');
  }
}

document.addEventListener('shopify:section:load', initializeMobileSubmenuState);
document.addEventListener('keydown', handleDesktopMenuKeyDown);
document.addEventListener('focusout', event => {
  document.querySelectorAll(`#AccessibleNav .${dismissedDesktopMenuClass}`).forEach(parent => {
    if (parent.contains(event.target) && !parent.contains(event.relatedTarget)) clearDesktopMenuDismissal(parent);
  });
});
document.addEventListener('mouseover', event => {
  if (!desktopNavigationMedia.matches) return;
  document.querySelectorAll(`#AccessibleNav .${dismissedDesktopMenuClass}`).forEach(parent => {
    // A real pointer re-entry is intentional; moving within it after Escape is not.
    if (parent.contains(event.target) && !parent.contains(event.relatedTarget)) clearDesktopMenuDismissal(parent);
  });
});
function resetDesktopDropdowns() {
  document.querySelectorAll('#AccessibleNav .site-nav--has-dropdown').forEach(parent => {
    clearDesktopMenuDismissal(parent);
    parent.classList.remove('nav-hover');
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initializeMobileMenuBreakpoint, { once: true });
} else {
  initializeMobileMenuBreakpoint();
}
